<template>
  <v-card>
    <v-card-title class="primary">
    	<h3 style="font-size: 18px; color: #FFF; font-weight: 500">Filtro</h3>
    </v-card-title>
    <v-card-text class="px-4">
      <v-flex xs12>
        <v-radio-group v-model="tipoFiltroAplicado" class="my-0 pt-1" @onchange="verificarTipoFiltroAtivo">
          <span class="themeGrey--text body-1">Selecione um tipo de filtro</span>
          <v-layout>
            <v-flex sm12 d-flex align-center v-for="item in tiposFiltros" :key="item.titulo">
              <v-radio :label="item.titulo" :value="item.value"></v-radio>
            </v-flex>
          </v-layout>
        </v-radio-group>
      </v-flex>
      <v-form v-if="this.tipoFiltroAplicado === 'APOLICES'" ref="formFiltro">
        <v-select
          v-model="filtroModel.listaIdStatus"
          :items="propostaStatusList"
          placeholder="Selecione uma opção"

          label="Status da Apólice/Proposta"
          item-value="id"
          item-text="titulo"
          multiple
        >
          <template v-slot:selection="{ item, index }"> 
            <span v-if="index === 0">{{ item.titulo }} </span>
            <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdStatus.length - 2 }} outros)
            </span>
			      <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensStatus">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosStatus }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
        <v-select
          v-model="filtroModel.listaIdTecnicoResponsavel"
          :items="propostaTecnicoResponsavelList"
          placeholder="Selecione uma opção"

          label="Tecnico Responsável da Apólice"
          item-value="id"
          item-text="nome"
          multiple
        >
          <template v-slot:selection="{ item, index }"> 
            <span v-if="index === 0">{{ item.nome }} </span>
            <span v-if="index === 1">,&nbsp{{ item.nome }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdTecnicoResponsavel.length - 2 }} outros)
            </span>
			      <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensTecnicoResponsavel">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosTecnicoResponsavel }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
        <v-select
          v-model="filtroModel.idInicioVigencia"
          :items="inicioVigenciaList"
          label="Início da Vigência"
          placeholder="Selecione uma opção"
          item-value="id"
          item-text="titulo"
        >
        </v-select>
        <v-select
          v-model="filtroModel.listaIdEnderecoUf"
          :items="ufsLista"
          placeholder="Selecione uma opção"
          label="Região"
          item-value="id"
          item-text="titulo"
          multiple
        >
          <template v-slot:selection="{ item, index }"> 
            <span v-if="index === 0">{{ item.titulo }} </span>
            <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdEnderecoUf.length - 2 }} outros)
            </span>
            <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensRegiao">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosRegiao }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
        <v-select
          v-model="filtroModel.listaIdSeguro"
          :items="segurosLista"
          placeholder="Selecione uma opção"
          label="Tipo Seguro"
          item-value="id"
          item-text="titulo"
          multiple
        >
          <template v-slot:selection="{ item, index }"> 
            <span v-if="index === 0">{{ item.titulo }} </span>
            <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdSeguro.length - 2 }} outros)
            </span>
            <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensSeguro">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosSeguro }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
        <v-select
          v-model="filtroModel.listaIdCobertura"
          :items="coberturasLista"
          placeholder="Selecione uma opção"
          label="Tipo de cobertura"
          item-value="id"
          item-text="titulo"
          multiple
        >
          <template v-slot:selection="{ item, index }"> 
            <span v-if="index === 0">{{ item.titulo }} </span>
            <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdCobertura.length - 2 }} outros)
            </span>
            <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensCobertura">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosCobertura }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
        <v-select
          v-model="filtroModel.listaIdCategoriaVeiculo"
          :items="categoriaVeiculoLista"
          placeholder="Selecione uma opção"
          label="Tipo de categoria"
          item-value="id"
          item-text="titulo"
          multiple
        >
          <template v-slot:selection="{ item, index }"> 
            <span v-if="index === 0">{{ item.titulo }} </span>
            <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdCategoriaVeiculo.length - 2 }} outros)
            </span>
            <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensCategoriaVeiculo">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosCategoriaVeiculo }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
      </v-form>
      <v-form v-if="this.tipoFiltroAplicado === 'ENDOSSOS'" ref="formFiltro">
        <v-select
          v-model="filtroModel.listaIdStatusEndosso"
          :items="endossoStatusList"
          placeholder="Selecione uma opção"

          label="Status do Endosso"
          item-value="id"
          item-text="titulo"
          multiple
        >
          <template v-slot:selection="{ item, index }"> 
            <span v-if="index === 0">{{ item.titulo }} </span>
            <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdStatusEndosso.length - 2 }} outros)
            </span>
			      <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensStatusEndosso">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosStatusEndosso }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
        <v-select
          v-model="filtroModel.listaIdTecnicoResponsavelEndosso"
          :items="propostaTecnicoResponsavelList"
          placeholder="Selecione uma opção"

          label="Tecnico Responsável do Endosso"
          item-value="id"
          item-text="nome"
          multiple
        >
          <template v-slot:selection="{ item, index }"> 
            <span v-if="index === 0">{{ item.nome }} </span>
            <span v-if="index === 1">,&nbsp{{ item.nome }} &nbsp </span>
            <span v-if="index === 2">
              (+{{ filtroModel.listaIdTecnicoResponsavelEndosso.length - 2 }} outros)
            </span>
			      <span></span>
          </template>
          <template v-slot:prepend-item>
            <v-list-tile ripple @click="selecionarTodosItensTecnicoResponsavelEndosso">
              <v-list-tile-action>
                <v-icon style="color: #00456e" class="material-icons-outlined">
                  {{ iconeSelecionarTodosTecnicoResponsavelEndosso }}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Selecionar todos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
      </v-form>
    </v-card-text>
	<v-divider></v-divider>
	<v-card-actions class="px-4">
		<v-layout row wrap>
			<v-flex md12 xs12>
				<v-btn color="primary" block @click="tratamentoFiltrarItens" :disabled="desabilitarBotaoFiltrar">
					Filtrar {{ tipoFiltroAplicado }}
				</v-btn>
				<div class="special-flex-filtro">
					<v-btn color="secondary" flat @click="tratamentoFecharModalFiltro">
						Fechar
					</v-btn>
				
					<v-btn color="secondary" flat @click="tratamentoLimparFiltro">
						Limpar
					</v-btn>
				</div>
			</v-flex>
			
		</v-layout>
	</v-card-actions>
  </v-card>
</template>
<script>


export default {
  name: "ModalFiltro",
  props: {
    propostaStatusList: {
      type: Array,
      required: false
    },
    endossoStatusList: {
      type: Array,
      required: false
    },
    propostaTecnicoResponsavelList: {
      type: Array,
      required: false
    },
	  dadosFiltroAtivado: {
      type: Object,
      required: false
    },
    inicioVigenciaList: {
      type: Array,
      required: true
    }, 
    coberturasLista: {
      type: Array,
      required: true
    },
    filtroAtivado: {
      type: Boolean,
      required: true,
    },
    ufsLista: {
      type: Array,
      required: true
    },
    categoriaVeiculoLista: {
      type: Array,
      required: true
    },
    segurosLista: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      listaPropostaStatus: [],
      tipoFiltroAplicado: 'APOLICES',
      tiposFiltros: [
        {
          value: 'APOLICES',
          titulo: "Apólice",
        },
        {
          value: 'ENDOSSOS',
          titulo: "Endosso",
        },
      ],
      filtroModel: {
			  listaIdStatus: [],
        idInicioVigencia: null,
        listaIdCobertura: [],
        listaIdEnderecoUf: [],
        listaIdCategoriaVeiculo: [],
        listaIdSeguro: [],
        listaIdTecnicoResponsavel: [],
        listaIdStatusEndosso: [],
        listaIdTecnicoResponsavelEndosso: [],
        tipoFiltroAtivo: 'APOLICES',
	    },
	    regras: {
		    notNull: [v => !!v || "Você não pode deixar este campo em branco"],
	    }
    };
  },
  mounted() {
    const objetoSessionStorage = sessionStorage.getItem("filtroObjetoString");
    this.limparFormFiltro();
    if(objetoSessionStorage != null ) {
      const modeloFiltro = JSON.parse(objetoSessionStorage);
      this.filtroModel = {...modeloFiltro};
      this.$emit('filtrarDadosModal', this.filtroModel);
    }
  },
  watch: {
    dadosFiltroAtivado(val) {
      if(val != null) {
        this.filtroModel = this.dadosFiltroAtivado;
      }
    }
  },
  computed: {
    validaFormFiltroApolice() {
      return this.filtroModel.listaIdStatus.length > 0 || 
        this.filtroModel.idInicioVigencia ||
        this.filtroModel.listaIdCobertura.length > 0 || 
        this.filtroModel.listaIdCategoriaVeiculo.length > 0 || 
        this.filtroModel.listaIdEnderecoUf.length > 0 ||
        this.filtroModel.listaIdSeguro.length > 0 ||
        this.filtroModel.listaIdTecnicoResponsavel.length > 0 
    },
    validaFormFiltroEndosso() {
      return this.filtroModel.listaIdStatusEndosso.length > 0 || 
        this.filtroModel.listaIdTecnicoResponsavelEndosso.length > 0
    },
    desabilitarBotaoFiltrar() {
      if (this.tipoFiltroAplicado === 'APOLICES' && !this.validaFormFiltroApolice) {
        return true;
      } else if (this.tipoFiltroAplicado === 'ENDOSSOS' && !this.validaFormFiltroEndosso) {
        return true;
      } else {
        return false;
      }
    },
    igualUmItemStatus() {
      return (
        this.filtroModel.listaIdStatus.length > 0 && !this.igualTodosItensStatus
    	);
    },
    igualUmItemStatusEndosso() {
      return (
        this.filtroModel.listaIdStatusEndosso.length > 0 && !this.igualTodosItensStatusEndosso
    	);
    },
    igualUmItemTecnicoResponsavel() {
      return (
        this.filtroModel.listaIdTecnicoResponsavel.length > 0 && !this.igualTodosItensTecnicoResponsavel
    	);
    },
    igualUmItemTecnicoResponsavelEndosso() {
      return (
        this.filtroModel.listaIdTecnicoResponsavelEndosso.length > 0 && !this.igualTodosItensTecnicoResponsavelEndosso
    	);
    },
    iconeSelecionarTodosStatus() {
      if (this.igualTodosItensStatus) return "check_box";
      if (this.igualUmItemStatus) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    iconeSelecionarTodosStatusEndosso() {
      if (this.igualTodosItensStatusEndosso) return "check_box";
      if (this.igualUmItemStatusEndosso) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    iconeSelecionarTodosTecnicoResponsavel() {
      if (this.igualTodosItensTecnicoResponsavel) return "check_box";
      if (this.igualUmItemTecnicoResponsavel) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    iconeSelecionarTodosTecnicoResponsavelEndosso() {
      if (this.igualTodosItensStatusEndosso) return "check_box";
      if (this.igualUmItemTecnicoResponsavelEndosso) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualTodosItensStatus() {
      return this.filtroModel.listaIdStatus.length === this.propostaStatusList.length;
    },
    igualTodosItensTecnicoResponsavel() {
      return this.filtroModel.listaIdTecnicoResponsavel.length === this.propostaTecnicoResponsavelList.length;
    },
    igualTodosItensStatusEndosso() {
      return this.filtroModel.listaIdStatusEndosso.length === this.endossoStatusList.length;
    },
    igualTodosItensTecnicoResponsavelEndosso() {
      return this.filtroModel.listaIdTecnicoResponsavelEndosso.length === this.propostaTecnicoResponsavelList.length;
    },
    igualUmItemCobertura() {
      return (
        this.filtroModel.listaIdCobertura.length > 0 && !this.igualTodosItensCobertura
    	);
    },
    igualTodosItensCobertura() {
      return this.filtroModel.listaIdCobertura.length === this.coberturasLista.length;
    },
    iconeSelecionarTodosCobertura() {
      if (this.igualTodosItensCobertura) return "check_box";
      if (this.igualUmItemCobertura) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualUmItemSeguro() {
      return (
        this.filtroModel.listaIdSeguro.length > 0 && !this.igualTodosItensSeguro
    	);
    },
    igualTodosItensSeguro() {
      return this.filtroModel.listaIdSeguro.length === this.segurosLista.length;
    },
    iconeSelecionarTodosSeguro() {
      if (this.igualTodosItensSeguro) return "check_box";
      if (this.igualUmItemSeguro) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualUmItemCategoriaVeiculo() {
      return (
        this.filtroModel.listaIdCategoriaVeiculo.length > 0 && !this.igualTodosItensCategoriaVeiculo
      );
    },
    igualTodosItensCategoriaVeiculo() {
      return this.filtroModel.listaIdCategoriaVeiculo.length === this.categoriaVeiculoLista.length;
    },
    iconeSelecionarTodosCategoriaVeiculo() {
      if (this.igualTodosItensCategoriaVeiculo) return "check_box";
      if (this.igualUmItemCategoriaVeiculo) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
    igualUmItemRegiao() {
      return (
        this.filtroModel.listaIdEnderecoUf.length > 0 && !this.igualTodosItensRegiao
    	);
    },
    igualTodosItensRegiao() {
      return this.filtroModel.listaIdEnderecoUf.length === this.ufsLista.length;
    },
    iconeSelecionarTodosRegiao() {
      if (this.igualTodosItensRegiao) return "check_box";
      if (this.igualUmItemRegiao) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },
  },
  methods: {
    verificarTipoFiltroAtivo() {
      if (this.tipoFiltroAplicado === 'APOLICES') {
        this.limparFiltroEndosso();
      } else if (this.tipoFiltroAplicado === 'ENDOSSOS') {
        this.limparFiltroApolice();
      }
    },
    tratamentoLimparFiltro() {
      this.$emit('formFiltroLimpo', true);
      this.limparFormFiltro();
    },
    selecionarTodosItensStatus() {
    	this.$nextTick(() => {
        if (this.igualTodosItensStatus) {
          this.filtroModel.listaIdStatus = [];
        } else {
          const listagemItens = this.propostaStatusList.slice();
          this.filtroModel.listaIdStatus = [];
          for (var listagemItem of listagemItens) {
            this.filtroModel.listaIdStatus.push(listagemItem.id);
          }
        }
      });
    },
    selecionarTodosItensStatusEndosso() {
    	this.$nextTick(() => {
        if (this.igualTodosItensStatusEndosso) {
          this.filtroModel.listaIdStatusEndosso = [];
        } else {
          const listagemItens = this.endossoStatusList.slice();
          this.filtroModel.listaIdStatusEndosso = [];
          for (var listagemItem of listagemItens) {
            this.filtroModel.listaIdStatusEndosso.push(listagemItem.id);
          }
        }
      });
    },
    selecionarTodosItensTecnicoResponsavel() {
    	this.$nextTick(() => {
        if (this.igualTodosItensTecnicoResponsavel) {
          this.filtroModel.listaIdTecnicoResponsavel = [];
        } else {
          const listagemItensTecnicoResponsavel = this.propostaTecnicoResponsavelList.slice();
          this.filtroModel.listaIdTecnicoResponsavel = [];
          for (var tecnicoResponsavel of listagemItensTecnicoResponsavel) {
            this.filtroModel.listaIdTecnicoResponsavel.push(tecnicoResponsavel.id);
          }
        }
      });
    },
    selecionarTodosItensTecnicoResponsavelEndosso() {
    	this.$nextTick(() => {
        if (this.igualTodosItensTecnicoResponsavelEndosso) {
          this.filtroModel.listaIdTecnicoResponsavelEndosso = [];
        } else {
          const listagemItensTecnicoResponsavelEndosso = this.propostaTecnicoResponsavelList.slice();
          this.filtroModel.listaIdTecnicoResponsavelEndosso = [];
          for (var tecnicoResponsavelEndosso of listagemItensTecnicoResponsavelEndosso) {
            this.filtroModel.listaIdTecnicoResponsavelEndosso.push(tecnicoResponsavelEndosso.id);
          }
        }
      });
    }, 
    selecionarTodosItensCobertura() {
    	this.$nextTick(() => {
        if (this.igualTodosItensCobertura) {
          this.filtroModel.listaIdCobertura = [];
        } else {
          const listagemItens = this.coberturasLista.slice();
          this.filtroModel.listaIdCobertura = [];
          for (var listagemItem of listagemItens) {
            this.filtroModel.listaIdCobertura.push(listagemItem.id);
          }
        }
      });
    },
    selecionarTodosItensSeguro() {
    	this.$nextTick(() => {
        if (this.igualTodosItensSeguro) {
          this.filtroModel.listaIdSeguro = [];
        } else {
          const listagemItens = this.segurosLista.slice();
          this.filtroModel.listaIdSeguro = [];
          for (var listagemItem of listagemItens) {
            this.filtroModel.listaIdSeguro.push(listagemItem.id);
          }
        }
      });
    },
    selecionarTodosItensCategoriaVeiculo() {
    	this.$nextTick(() => {
        if (this.igualTodosItensCategoriaVeiculo) {
          this.filtroModel.listaIdCategoriaVeiculo = [];
        } else {
          const listagemItens = this.categoriaVeiculoLista.slice();
          this.filtroModel.listaIdCategoriaVeiculo = [];
          for (var listagemItem of listagemItens) {
            this.filtroModel.listaIdCategoriaVeiculo.push(listagemItem.id);
          }
        }
      });
    }, 
    selecionarTodosItensRegiao() {
    	this.$nextTick(() => {
        if (this.igualTodosItensRegiao) {
          this.filtroModel.listaIdEnderecoUf = [];
        } else {
          const listagemItens = this.ufsLista.slice();
          this.filtroModel.listaIdEnderecoUf = [];
          for (var listagemItem of listagemItens) {
            this.filtroModel.listaIdEnderecoUf.push(listagemItem.id);
          }
        }
      });
    }, 
    tratamentoFiltrarItens() {
      if (this.tipoFiltroAplicado === 'APOLICES') {
        this.filtroModel.tipoFiltroAtivo = this.tipoFiltroAplicado;
        this.$emit('filtrarDadosModal', this.filtroModel);
        sessionStorage.setItem(
          "filtroObjetoString", 
          JSON.stringify(this.filtroModel)
        );
      } else if (this.tipoFiltroAplicado === 'ENDOSSOS') {
        this.filtroModel.tipoFiltroAtivo = this.tipoFiltroAplicado;
        this.$emit('filtrarDadosModal', this.filtroModel);
        sessionStorage.setItem(
          "filtroObjetoString", 
          JSON.stringify(this.filtroModel)
        );
      }
      
      this.$emit('fecharModalFiltro');
    },
    tratamentoFecharModalFiltro() {
      this.$emit('fecharModalFiltro');
      if(!this.filtroAtivado) {
        this.limparFormFiltro();
      }
    },
    limparFiltroApolice() {
      this.filtroModel.listaIdStatus = [];
      this.filtroModel.listaIdCobertura = [];
      this.filtroModel.listaIdCategoriaVeiculo = [];
      this.filtroModel.idInicioVigencia = null;
      this.filtroModel.listaIdEnderecoUf = [];
      this.filtroModel.listaIdSeguro = [];
      this.filtroModel.listaIdTecnicoResponsavel = [];
      this.filtroModel.tipoFiltroAtivo = null;
      this.tipoFiltroAplicado = 'ENDOSSOS';
      //this.$refs.formFiltro.reset();
      //this.$refs.formFiltro.resetValidation();
    },
    limparFiltroEndosso() {
      this.filtroModel.listaIdStatusEndosso = [];
      this.filtroModel.listaIdTecnicoResponsavelEndosso = [];
      this.filtroModel.tipoFiltroAtivo = null;
      this.tipoFiltroAplicado = 'APOLICES';
      //this.$refs.formFiltro.reset();
      //this.$refs.formFiltro.resetValidation();
    },
    limparFormFiltro() {
      this.limparFiltroApolice();
      this.limparFiltroEndosso();
      this.$refs.formFiltro.reset();
      this.$refs.formFiltro.resetValidation();
    }
  }
};
</script>

<style>
  .special-flex-filtro {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalFiltro.vue